import Layout from "@components/layout";
import { DashboardPage } from "@pages";
import { RouteConfig } from "@types";

export const dashboard = (): RouteConfig => {
  return {
    path: "dashboard",
    element: <Layout />,
    redirect: "main",
    children: [
      { path: "main", element: <DashboardPage />, navKey: "dashboard" },
    ],
  };
};

export default dashboard;
